export const onReady = 'onReady';
export const onLogin = 'onLogin';
export const onLogout = 'onLogout';

export default {
  onReady,
  onLogin,
  onLogout,
};



// WEBPACK FOOTER //
// ./src/Events/types.js